import React, { memo } from "react";

import BaseNode from "../Base/Base";
import { type FlowItemFlowEnd } from "../../../types";
import { type FlowItemBase } from "../types";
import { type ExtrasTypes } from "../../../Extras/types";
import FlowEndCard from "../../../../../../../components/cards/flowDesignerDropCard/FlowEndCard/FlowEndCard";

export interface FlowEndNodeProps {
  type: ExtrasTypes.FlowEnd;
  data: FlowItemFlowEnd & FlowItemBase;
}

const FlowEndNode: React.FC<FlowEndNodeProps> = ({ type, data }) => {
  return (
    <BaseNode data={{ ...data, canConnect: false }} styles={{ card: "flow-end" }}>
      <FlowEndCard item={{ ...data, elementType: type }} />
    </BaseNode>
  );
};

export default memo(FlowEndNode);
